<div class="config-container">
    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ 'meter.config.error_loading' | translate }}</p>
    </div>

    <!-- Settings Form -->
    <div *ngIf="!loading && !error && settings" class="settings-form">
        <div *ngIf="notFound" class="info-banner">
            <mat-icon>info_outline</mat-icon>
            <span>{{ 'meter.config.using_defaults' | translate }}</span>
        </div>

        <!-- General Settings -->
        <section class="settings-section">
            <h3 class="section-title">{{ 'meter.config.section_general' | translate }}</h3>
            <div class="form-grid">
                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.total_meter_accounts' | translate }}</label>
                    <input type="number" class="field-input" min="1" [(ngModel)]="settings.totalMeterAccounts">
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.active_threshold_days' | translate }}</label>
                    <input type="number" class="field-input" min="1" [(ngModel)]="settings.activeThresholdDays">
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.min_days_projection' | translate }}</label>
                    <input type="number" class="field-input" min="1" [(ngModel)]="settings.minDaysForProjection">
                </div>
            </div>
        </section>

        <!-- Water Fixed Monthly Rates -->
        <section class="settings-section">
            <h3 class="section-title">{{ 'meter.config.section_water_fixed' | translate }}</h3>
            <div class="form-grid">
                <div class="field-group" *ngFor="let size of pipeSizes">
                    <label class="field-label">{{ size }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.waterFixedMonthly[size]">
                        <span class="field-suffix">$</span>
                    </div>
                </div>
            </div>
        </section>

        <!-- Sewer Fixed Monthly Rates -->
        <section class="settings-section">
            <h3 class="section-title">{{ 'meter.config.section_sewer_fixed' | translate }}</h3>
            <div class="form-grid">
                <div class="field-group" *ngFor="let size of pipeSizes">
                    <label class="field-label">{{ size }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.sewerFixedMonthly[size]">
                        <span class="field-suffix">$</span>
                    </div>
                </div>
            </div>
        </section>

        <!-- Consumption Rates -->
        <section class="settings-section">
            <h3 class="section-title">{{ 'meter.config.section_consumption' | translate }}</h3>
            <div class="form-grid">
                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.water_consumption_monthly' | translate }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.waterConsumptionMonthly">
                        <span class="field-suffix">$</span>
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.sewer_consumption_monthly' | translate }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.sewerConsumptionMonthly">
                        <span class="field-suffix">$</span>
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.water_additional_per_m3' | translate }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.waterAdditionalPerM3">
                        <span class="field-suffix">$/m³</span>
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.sewer_additional_per_m3' | translate }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="0.01"
                               [(ngModel)]="settings.billing.sewerAdditionalPerM3">
                        <span class="field-suffix">$/m³</span>
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">{{ 'meter.config.min_monthly_consumption' | translate }}</label>
                    <div class="field-with-suffix">
                        <input type="number" class="field-input" min="0" step="1"
                               [(ngModel)]="settings.billing.minMonthlyConsumptionM3">
                        <span class="field-suffix">m³</span>
                    </div>
                </div>
            </div>
        </section>

        <!-- Save Button -->
        <div class="save-bar">
            <button class="save-button" (click)="onSave()" [disabled]="saving">
                <mat-spinner *ngIf="saving" diameter="18"></mat-spinner>
                <span *ngIf="!saving">{{ 'meter.config.save' | translate }}</span>
                <span *ngIf="saving">{{ 'meter.config.saving' | translate }}</span>
            </button>
            <span *ngIf="saveSuccess" class="save-success">
                <mat-icon>check_circle</mat-icon>
                {{ 'meter.config.save_success' | translate }}
            </span>
        </div>
    </div>
</div>
